import { connectHits } from 'react-instantsearch-dom'
import Phrase from '../../libs/translationsUtils/phrase'
import SuggestedTopicsList from './SuggestedTopicsList'

export const SuggestedTopicsListContainer = ({ hits }) => {
  if (!hits.length) return null
  return (
    <div>
      <div className='topic-create_suggestions-title'>
        <Phrase p='related.topics.title' />
      </div>
      <SuggestedTopicsList hits={hits} />
    </div>
  )
}

const SuggestedTopicsListWrapper = connectHits(SuggestedTopicsListContainer)

export default SuggestedTopicsListWrapper
